import isFinite from 'lodash/isFinite';
import timeStringToSeconds from '../time-string-to-seconds/index.tsx';

// eslint-disable-next-line jira/import/no-anonymous-default-export
export default (timeString: string): boolean => {
	// We don't care about daysPerWeek or hoursPerDay - we only need to test that the value can be parsed.
	const result = timeStringToSeconds(1, 1)(timeString);
	return result !== null && isFinite(result);
};
